<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Desinvesteringsbijtelling
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Heeft de vennootschap bedrijfsmiddelen vervreemd (onder andere verkocht of geschonken) waarvoor in vorige jaren
                    investeringsaftrek is toegepast? Dan kan het zijn dat een deel van die aftrek terugbetaald moet woden. Dit gebeurt
                    via de desinvesteringsbijtelling. Je bent verplicht een deel van de aftrek terug te betalen als u aan de volgende 2
                    voorwaarden voldoet:</p>
                <ul>
                    <li>De vennootschap verkoopt of schenkt de bedrijfsmiddelen binnen 5&nbsp;jaar na het begin van het kalenderjaar
                        waarin u de
                        investering deed.
                    </li>
                    <div *ngIf="this.year === 2024">
                        <li>De waarde van die bedrijfsmiddelen is gezamenlijk hoger dan €&nbsp;2.800 (2024).
                        </li>
                    </div>
                    <div *ngIf="this.year === 2023">
                        <li>De waarde van die bedrijfsmiddelen is gezamenlijk hoger dan €&nbsp;2.600 (2023).
                        </li>
                    </div>
                </ul>

                <p>Het bedrag van de desinvesteringsbijtelling is afhankelijk van het bedrag waarvoor je het bedrijfsmiddel hebt
                    vervreemd. De bijtelling is echter nooit hoger dan het bedrag van de eerder gekregen aftrek. Neem voor het
                    bedrag dat je moet bijtellen hetzelfde percentage dat je bij de eerdere investeringsaftrek hebt toegepast.</p>

                <p>De Belastingdienst ziet het ook als vervreemding, als je het bedrijfsmiddel:</p>
                <ul>
                    <li>bestemt voor verhuur (dit geldt alleen bij de Kleinschaligheidsinvesteringsaftrek, niet bij de Energie- en
                        de Milieu-investeringsaftrek).
                    </li>
                    <li>niet binnen 12&nbsp;maanden na de investering in gebruik neemt en binnen die periode ook nog niet 25% van de
                        aankoopprijs hebt betaald.
                    </li>
                    <li>niet in gebruik neemt binnen&nbsp;3 jaar na het begin van het kalenderjaar waarin je de investering deed.
                    </li>
                </ul>

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                KIA Caribisch gebied
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De ‘Uitvoeringsregeling investeringsaftrek Aruba, Curaçao, Sint Maarten en de BES eilanden 2010’ biedt mogelijkheid
                invetseringsaftrek te ontvangen voor bedrijfsmiddelen die zijn toe te rekenen aan een vaste
                inrichting op deze eilanden. Vermeld de kleinschaligheidsinvesteringsaftrek voor investeringen die worden toegerekend
                aan het ondernemingsvermogen van de vennootschap op Aruba, Bonaire, Curaçao, Saba, Sint-Eustatius en Sint-Maarten.

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Restant KIA
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vermeld hier een restant kleinschaligheidsinvesteringsaftrek uit voorgaande jaren
            </div>
        </div>
    </div>
</div>
